import cx from 'classnames';

import { FilterItem } from './FilterItem';
import s from './Filters.module.css';
import { IFiltersProps } from './types';

const Filters = <FilterName extends string>({
  value,
  config,
  onChange,
  children,
  actionWrapperClassName,
}: IFiltersProps<FilterName>) => (
  <div className={s.filters}>
    {config.map(
      ({ title, name, placeholder, options, type, icon, hasOneLineLabel, isClearable }) => (
        <div className={s.item} key={name}>
          <FilterItem<FilterName>
            value={value}
            onChange={onChange}
            title={title}
            name={name}
            placeholder={placeholder}
            options={options}
            type={type}
            icon={icon}
            hasOneLineLabel={hasOneLineLabel}
            isClearable={isClearable}
          />
        </div>
      ),
    )}
    {children && (
      <div className={cx(s.child, actionWrapperClassName)} key="#children">
        {children}
      </div>
    )}
  </div>
);

export { Filters };
